import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { LeafElement } from "../../components/leaf-element.js";
import { SlotController } from "../../utilities/slot.js";
import "../../components/icon/icon.js";
import "../../utilities/events.js";
import "../../components/icon/icon.component.js";
import "lit/directives/unsafe-svg.js";
import "../../utilities/cache-fetch.js";
import "../../utilities/watch.js";
import "../../components/icon/library.js";
import "../../components/icon/iconset.system.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.base-c-value-prop {\n  display: flex;\n  flex-direction: column;\n  gap: var(--leaf-spacing-16);\n}\n.base-c-value-prop ::slotted([slot=meta]) {\n  font-family: var(--leaf-typography-body-small-font-family);\n  font-size: var(--leaf-typography-body-small-font-size);\n  font-weight: var(--leaf-typography-body-small-font-weight);\n  line-height: var(--leaf-typography-body-small-line-height);\n  -webkit-text-decoration: var(--leaf-typography-body-small-text-decoration);\n          text-decoration: var(--leaf-typography-body-small-text-decoration);\n  text-transform: var(--leaf-typography-body-small-text-transform);\n}\n.base-c-value-prop ::slotted([slot=meta]:not(:empty)) {\n  margin-bottom: var(--leaf-spacing-4);\n}\n.base-c-value-prop ::slotted([slot=heading]) {\n  font-family: var(--leaf-typography-title-default-font-family) !important;\n  font-size: var(--leaf-typography-title-default-font-size) !important;\n  font-weight: var(--leaf-typography-title-default-font-weight) !important;\n  line-height: var(--leaf-typography-title-default-line-height) !important;\n  -webkit-text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n          text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n  text-transform: var(--leaf-typography-title-default-text-transform) !important;\n  color: var(--leaf-color-content-brand-strong);\n  margin: 0 !important;\n}\n.base-c-value-prop.base-c-value-prop--center {\n  align-items: center;\n}\n\n.base-c-value-prop--icon-container ::slotted([slot=icon]) {\n  --icon-height: var(--leafdcws-value-prop-icon-height);\n  --icon-width: var(--leafdcws-value-prop-icon-width);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class BaseValueProp extends LeafElement {
  constructor() {
    super(...arguments);
    this.slotController = new SlotController(this);
  }
  render() {
    return html`<div class="base-c-value-prop ${this.alignment ? `base-c-value-prop--${this.alignment}` : ""}">
      ${this.slotController.hasNamedSlot("icon") ? html`
            <div class="base-c-value-prop--icon-container">
              <slot name="icon"></slot>
            </div>
          ` : ``}
      <div class="base-c-value-prop--heading">
        <slot name="meta"></slot>
        <slot name="heading"></slot>
      </div>
      <slot></slot>
      <slot name="cta"></slot>
    </div>`;
  }
}
BaseValueProp.styles = unsafeCSS(styles);
__decorateClass([
  property()
], BaseValueProp.prototype, "alignment", 2);
export {
  BaseValueProp
};
//# sourceMappingURL=value-prop.js.map
